import React from "react";

const ProfileInfoSkeleton = () => (
  <div className="ea-card">
    <div className="ea-identity">
      <div className="shimmer" style={{ width: 46, height: 46, borderRadius: "50%" }} />
      <div className="shimmer" style={{ width: 180, height: 20 }} />
    </div>
    <div className="ea-card-body ea-grid">
      {Array.from({ length: 6 }).map((_, index) => (
        <div key={index} className="shimmer" style={{ height: 52, width: "100%" }} />
      ))}
    </div>
  </div>
);

export default ProfileInfoSkeleton;
